import { useEffect, useState } from "react";
import { api } from "./api";

export const DEFAULT_SETTINGS = {
  brand_name: "S H & SONS ®", website: "https://www.shandsons.in",
  email: "hello@shandsons.in", phone_primary: "+91 9870651826",
  address: "Chandausi Road, Nanpur, Moradabad, Uttar Pradesh 244001, India",
  copyright: "Manufacturer & Exporter since 1986. All rights reserved.",
  instagram: "https://www.instagram.com/shandsons___/",
  facebook: "https://www.facebook.com/shandsons/",
  linkedin: "https://www.linkedin.com/company/shandsons/",
  whatsapp: "https://wa.me/919870651826",
};
export default function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    let active = true;
    api.site("settings").then(data => { if (active) setSettings({ ...DEFAULT_SETTINGS, ...data }); }).catch(() => {});
    return () => { active = false; };
  }, []);
  return settings;
}
